export class HammerJS {
  private static instance: HammerJS;
  public hm?: HammerStatic;
  private promise: Promise<HammerStatic>;

  private constructor() {
    this.promise = import('hammerjs').then((HammerModule) => {
      this.hm = HammerModule.default;
      return this.hm;
    });
  }

  public getModule(): Promise<HammerStatic> {
    return this.promise;
  }

  public static getInstance(): HammerJS {
    if (!HammerJS.instance) {
      HammerJS.instance = new HammerJS();
    }

    return HammerJS.instance;
  }
}
